























































import { Component, Vue } from 'vue-property-decorator'
import moment from 'moment'
import { getCompanyInfoRequest , output,outputTrends , industrialRise,addEnergyTrend} from '@/api/enerySupervision'
import Tenthousand from './components/Tenthousand.vue'
import Tenthousandtow from './components/Tenthousandtow.vue'
import  NoData from '@/components/NoData'
@Component({
    name:'EquipmenEnergyEfficiency',
    components:{Tenthousand,Tenthousandtow,NoData}
})
export default class Login  extends Vue {
    private year:any=moment(new Date().getFullYear(), 'YYYY')
    private yearShowOne:boolean=false
    private tiemDefaultValue:string='全年'
    private timeArr:any[]=[
        {value:'全年',id:`00`},
        {value:'一月',id:`01`},
        {value:'二月',id:`02`},
        {value:'三月',id:`03`},
        {value:'四月',id:`04`},
        {value:'五月',id:`05`},
        {value:'六月',id:`06`},
        {value:'七月',id:`07`},
        {value:'八月',id:`08`},
        {value:'九月',id:`09`},
        {value:'十月',id:`10`},
        {value:'十一月',id:`11`},
        {value:'十二月',id:`12`},
    ]
    private month:any='00'
    private companyInfo:any=null
    private status:string = '1'
    private action:string='view'
    private code: string= ''
    private DateObj: any= {}
    private ant_button:boolean = true
    private supervisionYear: string= ''
    private dataone:any = {
        outputList:[],
        productionValueEnergyList:[],
        outputMoneyList:[],
        comprehensiveList:[],
        showData:false
    }
    private datatow:any = {
        outputList:[],
        productionValueEnergyList:[],
        outputMoneyList:[],
        comprehensiveList:[],
        showData:false
    }
    handleSearch(obj:any){
        const Time = new Date().getFullYear() -1
        Time == obj.startDate?this.ant_button = true:this.ant_button = false
        const params={
            enterpriseCode:this.code,
            statDate: obj.startDate,
            endDate:obj.endDate
        }
        this.init(params)
    }
     // 弹出日历和关闭日历的回调
    openChangeOne(status:any){
        if(status){
            this.yearShowOne =  true
        }else{
            this.yearShowOne =  false
        }
    }
    // 选择月份
    // handleChange(value:any) {
    //     this.month=value
    //     if(moment(this.year).format('YYYY')=='Invalid date'){
    //         this.$message.error('年份不能为空')
    //     }else if(value=='00'){
    //         this.DateObj.aboveDate=`${moment(this.year).format('YYYY')}`
    //         this.DateObj.belowDate= this.DateObj.aboveDate
    //         const params={
    //             enterpriseCode:this.code,
    //             statDate: this.DateObj.aboveDate,
    //         }
    //         this.init(params)
    //     }else{
    //         this.DateObj.aboveDate=`${moment(this.year).format('YYYY')}-${value}`
    //         this.DateObj.belowDate= this.DateObj.aboveDate
    //         const params={
    //             enterpriseCode:this.code,
    //             statDate: this.DateObj.aboveDate,
    //         }
    //         this.init(params)
    //     }
    // }
    // 得到年份选择器的值
    onYearChange(value:any){
        this.year = moment(value).format('YYYY')
        if(this.month=='00'){
            this.DateObj.aboveDate=this.year
        }else{
            this.DateObj.aboveDate=`${this.year}-${this.month}`
        }
        this.DateObj.belowDate= this.DateObj.aboveDate.length==4?this.DateObj.aboveDate-1:this.DateObj.aboveDate

        const params={
            enterpriseCode:this.code,
            statDate: this.DateObj.aboveDate,
        }
        this.init(params)
        this.yearShowOne = false
        // this.getUtilizationList(this.$route.query.code,this.year)
    }
    init(params:any){
        // this.getCompanyInfo(params.enterpriseCode)
        this.equipmentEnergy({
            enterpriseCode:params.enterpriseCode,
            year: params.statDate,
        })
        this.outputTrendsRequeryst(params)
        this.industrialRiseRequeryst({
            enterpriseCode:params.enterpriseCode,
            year: params.statDate,
        })
        this.addEnergyTrendRequeryst({
            enterpriseCode:params.enterpriseCode,
            year: params.statDate,
        })
        
    }
    async getCompanyInfo(code:any){
        const {status,data}=await getCompanyInfoRequest({enterpriseCode:code})
        if(status==0){
        this.companyInfo=data
        this.status = data.isOpenData
        }
    }
    async equipmentEnergy(Requestdata:any){
            const {status,data}=await output(Requestdata) 
            if(status == 0){
            Object.assign(this.dataone , data|| {showData: false})    
            this.dataone.showData = true
            }
            
    }

    async outputTrendsRequeryst(Requestdata: any){
        const {status,data}=await outputTrends(Requestdata)
        if(status == 0){
            this.dataone.outputList = data   
            setTimeout(() => {
            this.$forceUpdate()
            }, 0)
        }
    }
    async industrialRiseRequeryst(Requestdata:any){
        const {status,data}=await industrialRise(Requestdata)
        if(status == 0){
            Object.assign(this.datatow , data|| {showData: false})
            this.datatow.showData = true
        }
    }

    
    async addEnergyTrendRequeryst(Requestdata: any){
        const {status,data}=await addEnergyTrend(Requestdata)
        if(status == 0){   
            this.datatow.outputList = data
        }
    }
    
    created(){
        if(this.$route.query.encode!=undefined){
        this.code=this.$route.query.encode.toString()
        this.supervisionYear=this.$route.query.year.toString()
        this.DateObj.aboveDate=this.$route.query.year
        this.DateObj.belowDate=this.DateObj.aboveDate-1
        const params={
            enterpriseCode:this.code,
            statDate: this.supervisionYear,
        }
        this.init(params)
        this.action=this.$route.query.action.toString()
        }
    }
    mounted() {

    }
}
